import React, { FC } from 'react';
import styled from 'styled-components';
import { Icon } from '@beeline.com/bp-design-system';

export const TaskNotificationsIcon: FC<{ tasksToReviewCount: number }> = ({ tasksToReviewCount }) => (
  <StyledTaskNotificationsIcon>
    <StyledSystemIcon name="checklist" color="colorOnBackground" $hasNotifications={tasksToReviewCount > 0} />
  </StyledTaskNotificationsIcon>
);

const StyledTaskNotificationsIcon = styled.div`
  position: relative;
`;

const StyledSystemIcon = styled(Icon)<{ $hasNotifications: boolean }>`
  &::after {
    background-color: ${({ theme }) => theme.colorAlert};
    border-radius: 50%;
    content: '';
    display: ${({ $hasNotifications }) => ($hasNotifications ? 'block' : 'none')};
    height: 10px;
    position: absolute;
    right: -9px;
    top: -6px;
    width: 10px;
  }
`;
